import _ from 'underscore';

const defaultPermissions = ['email'];
const defaultFields = ['id', 'name', 'email'];

// eslint-disable-next-line camelcase
const ERROR_CODE_UNINITIAliZED = 'uninitialized';
// eslint-disable-next-line no-unused-vars
const ERROR_CODE_UNKNOWN = 'unknown';

export class FacebookLoginRepository {
  constructor({ deps }) {
    this.FB = deps.FB;
  }

  login({
    permissions = defaultPermissions,
    rerequest = false,
    onSuccess = _.noop,
    onFail = _.noop,
  } = {}) {
    if (!this.FB || !_.isFunction(this.FB.login)) {
      onFail(ERROR_CODE_UNINITIAliZED);
      return;
    }

    const loginOptions = {
      scope: permissions.join(','),
      return_scopes: true,
    };
    if (rerequest) {
      loginOptions.auth_type = 'rerequest';
    }

    this.FB.getLoginStatus((res) => {
      if (rerequest || !res || res.status !== 'connected') {
        this.FB.login((response) => {
          if (!response || response.error) {
            // todo: handle different errors
            onFail(response || ERROR_CODE_UNKNOWN);
            return;
          }

          const { status, authResponse } = response;
          if (status === 'connected') {
            const {
              accessToken,
              userID,
              expiresIn,
              grantedScopes: grantedScopesCSV = '',
            } = authResponse || {};

            const grantedScopes = grantedScopesCSV.split(',');
            const declinedScopes = _.difference(permissions, grantedScopes);
            // eslint-disable-next-line object-curly-newline
            onSuccess({ grantedScopes, declinedScopes, accessToken, userID, expiresIn });
          } else { // not_authorized, unknown
            onFail(response || ERROR_CODE_UNKNOWN);
          }
        }, loginOptions);
      } else {
        const { authResponse } = res || {};
        const { accessToken, userID } = authResponse || {};
        onSuccess({ accessToken, userID });
      }
    });
  }

  logout({ onSuccess = _.noop, onFail = _.noop } = {}) {
    if (!this.FB || !_.isFunction(this.FB.logout)) {
      onFail(ERROR_CODE_UNINITIAliZED);
      return;
    }

    try {
      this.FB.getLoginStatus((res) => {
        if (res && res.status === 'connected') {
          this.FB.logout((response) => {
            if (!response || response.error) {
              onFail(response || ERROR_CODE_UNKNOWN);
              return;
            }
            onSuccess();
          });
        } else {
          onSuccess();
        }
      });
    } catch (ex) {
      onFail(ex);
    }
  }

  getUserInfo({ fields = defaultFields, onSuccess = _.noop, onFail = _.noop } = {}) {
    if (!this.FB || !_.isFunction(this.FB.api)) {
      onFail(ERROR_CODE_UNINITIAliZED);
      return;
    }

    const userFields = fields.join(',');
    this.FB.api('/me', 'GET', { fields: userFields }, (response) => {
      if (!response || response.error) {
        onFail(response || ERROR_CODE_UNKNOWN);
        return;
      }
      onSuccess(response);
    });
  }
}

